module.exports = __webpack_public_path__ + "static/img/top.cf86a76e.png";